import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'dialog-privacy-policy',
  templateUrl: './dialog-privacy-policy.component.html',
  styleUrls: ['./dialog-privacy-policy.component.scss']
})
export class DialogPrivacyPolicyComponent {
  constructor(private dialogRef: MatDialogRef<DialogPrivacyPolicyComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
